(() => {
  const currentDocument = document.currentScript.ownerDocument;
  const arcGisApiLines = '//services1.arcgis.com/9meaaHE3uiba0zr8/arcgis/rest/services/Construction_Project_Lines_View/FeatureServer/0/query?';
  const arcGisApiMultipoints = '//services1.arcgis.com/9meaaHE3uiba0zr8/arcgis/rest/services/Construction_Project_Multipoints_View/FeatureServer/0/query?';
  const arcGisApiPolygons = '//services1.arcgis.com/9meaaHE3uiba0zr8/arcgis/rest/services/Construction_Project_Polygons_View/FeatureServer/0/query?';
  const drupalApi = '/jsonapi/node/projects?fields[node--projects]=path,body,sticky&filter[field_project_id]=';
  const mapUrl = '//stpaul.maps.arcgis.com/apps/webappviewer/index.html?id=55b963a97919474fb2b9b8940bffe5cf&find=';

  function _generateQueryParams(queryParams) {
    const hasLocationAndName = queryParams.length > 0 ? queryParams[0].includes('Location LIKE') : false;
    const locationAndNameQuery = queryParams.slice(0, 2).join(' OR ');
    const nonLocationAndNameQuery = queryParams.slice(2).join(' AND ');
    const defaultQuery = queryParams.join(' AND ');

    if (hasLocationAndName && queryParams.length > 2) {
      return `(${locationAndNameQuery}) AND ${nonLocationAndNameQuery}`;
    } else if (hasLocationAndName) {
      return locationAndNameQuery;
    } else {
      return defaultQuery;
    }
  }

  function _returnAllProjects(projects, projectIndex) {
    const searchResultTemplate = currentDocument.querySelector('#project-search-results');
    const loadMore = searchResultTemplate.shadowRoot.querySelector('.project-search__result-more');
    const projectStart = projectIndex ? projectIndex - 21 : 0;

    if (projects.length < projectIndex) loadMore.style = 'display: none;';

    return projects.sort((a, b) => b.Sticky - a.Sticky).filter((project, index) => index > projectStart && index <= projectIndex);
  }

  function _returnStickyProjects(projects) {
    return projects.filter((project) => project.Sticky);
  }

  function _returnNonStickyProjects(projects, projectIndex) {
    const searchResultTemplate = currentDocument.querySelector('#project-search-results');
    const loadMore = searchResultTemplate.shadowRoot.querySelector('.project-search__result-more');
    const projectStart = projectIndex ? projectIndex - 20 : 0;

    if (projects.length < projectIndex) loadMore.style = 'display: none;';

    return projects.filter((project, index) => !project.Sticky && index > projectStart && index <= projectIndex);
  }

  function _fetchDrupalApi(project) {
    return fetch(drupalApi + project.attributes.ProjectID)
      .then((response) => response.json())
      .then((json) => {
        if (json.data.length > 0) {
          project.attributes.DrupalUrl = json.data[0].attributes.path.alias;
          project.attributes.Description = json.data[0].attributes.body.summary;
          project.attributes.Sticky = json.data[0].attributes.sticky;
        } else {
          project.attributes.DrupalUrl = false;
          project.attributes.Description = false;
          project.attributes.Sticky = false;
        }

        return project.attributes;
      })
      .catch((e) => console.error(e));
  }

  function _getProjectDetails(projects, onLoad, loadMore, projectIndex) {
    const promises = projects.map((project) => _fetchDrupalApi(project));

    return Promise.all(promises).then((projects) => {
      if (onLoad) {
        return _returnStickyProjects(projects);
      } else if (loadMore) {
        return _returnNonStickyProjects(projects, projectIndex);
      } else {
        return _returnAllProjects(projects, projectIndex);
      }
    });
  }

  function _mergeProjects(projects, onLoad, loadMore, projectIndex) {
    const flattenedProjects = projects.map((apiEndpoint) => apiEndpoint.features).flat();
    return _getProjectDetails(flattenedProjects, onLoad, loadMore, projectIndex);
  }

  function _getProjects(self, queryParams, onLoad, loadMore, projectIndex) {
    const params = new URLSearchParams({
      f: 'pjson',
      geometryType: 'esriGeometryEnvelope',
      outFields: 'ProjectID,Name,Department,Location,StartYear,ProjType,Phase,Status',
      returnExceededLimitFeatures: true,
      returnGeometry: false,
      returnQueryGeometry: false,
      where: queryParams.length > 0 ? _generateQueryParams(queryParams) : '1 = 1',
      start: 0,
    });

    const arcGisApiLinesJson = fetch(arcGisApiLines + params).then((response) => response.json());
    const arcGisApiMultipointsJson = fetch(arcGisApiMultipoints + params).then((response) => response.json());
    const arcGisApiPolygonsJson = fetch(arcGisApiPolygons + params).then((response) => response.json());

    return Promise.all([arcGisApiLinesJson, arcGisApiMultipointsJson, arcGisApiPolygonsJson])
      .then((projects) => _mergeProjects(projects, onLoad, loadMore, projectIndex))
      .then((projects) => (projects.length > 0 ? projects.map((project) => self.render(project)) : self.renderNoResults()))
      .catch((e) => self.renderNoResults());
  }

  function _getQueryParams(formElements) {
    return Array.from(formElements)
      .map((element) => {
        if (element.name == 'Name' || element.name == 'Location') {
          return element.value ? `${element.name} LIKE '%${element.value}%'` : '';
        } else {
          return element.value ? `${element.name} = '${element.value}'` : '';
        }
      })
      .filter((value) => value !== '');
  }

  function _getSelectFields(self) {
    const params = new URLSearchParams({
      f: 'pjson',
      geometryType: 'esriGeometryEnvelope',
      outFields: 'StartYear,ProjType,Department,Phase,Status',
      returnExceededLimitFeatures: true,
      returnGeometry: false,
      returnQueryGeometry: false,
      where: '1 = 1',
    });

    return fetch(arcGisApiMultipoints + params)
      .then((response) => response.json())
      .then((data) => {
        const fields = data.fields.map((field) => {
          if (field.domain) {
            if (field.domain.codedValues) {
              return field.domain.codedValues.map((value) => value.name);
            }
          }
        });

        self.render(fields);
      })
      .catch((e) => console.error(e));
  }

  class ProjectSearchForm extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      const shadowRoot = this.attachShadow({ mode: 'open' });
      const template = currentDocument.querySelector('#project-search-form-template');
      const instance = template.content.cloneNode(true);
      const form = instance.querySelector('.project-search__form');
      const reset = form.querySelector('.project-search__reset');

      shadowRoot.appendChild(instance);
      form.addEventListener('submit', (e) => this.formSubmitEventHandler(e));
      reset.addEventListener('click', (e) => this.formReset(e));

      _getSelectFields(this);
    }

    formReset(e) {
      const form = this.shadowRoot.querySelector('.project-search__form');
      const formFields = this.shadowRoot.querySelectorAll('[data-selected');

      form.reset();
      Array.from(formFields).forEach((field) => (field.dataset.selected = ''));
    }

    formSubmitEventHandler(e) {
      e.preventDefault();
      const searchResultTemplate = currentDocument.querySelector('#project-search-results');
      const results = searchResultTemplate.shadow.querySelectorAll('.project-search__result');
      const errorMsg = searchResultTemplate.shadow.querySelector('.project-search__result-no-results');
      const loader = searchResultTemplate.shadow.querySelector('.project-search__result-loader');
      const loadMore = searchResultTemplate.shadowRoot.querySelector('.project-search__result-more');
      const name = this.shadowRoot.querySelector('#project-name');
      const location = this.shadowRoot.querySelector('#project-location');
      const formElements = e.target.elements;
      const queryParams = _getQueryParams(formElements);

      // Remove search results
      Array.from(results).map((result) => result.remove());

      // Show load more button if hidden
      loadMore.style = 'display: block;';

      // Show loader
      loader.style = 'display: inline-block;';

      // Remove error message
      if (errorMsg) {
        errorMsg.remove();
      }

      location.value = name.value;

      return queryParams.length > 0 ? _getProjects(searchResultTemplate, queryParams, false, false, 20) : _getProjects(searchResultTemplate, [], true, false, 20);
    }

    render(fieldValues) {
      const selectBoxes = this.shadowRoot.querySelectorAll('.project-search__select');

      Array.from(selectBoxes).map((select, i) => {
        if (fieldValues[i]) {
          fieldValues[i].map((value) => {
            const option = document.createElement('OPTION');
            option.value = value;
            option.textContent = value;
            select.appendChild(option);
          });
        }
      });
    }
  }

  class ProjectSearchResults extends HTMLElement {
    constructor() {
      super();
      this.shadow = this.attachShadow({ mode: 'open' });
      this.template = currentDocument.querySelector('#project-search-results-template');
    }

    connectedCallback() {
      const style = this.template.content.firstElementChild.cloneNode(true);
      const loader = this.template.content.children[2].cloneNode(true);
      const loadMore = this.template.content.lastElementChild.cloneNode(true);

      this.shadow.appendChild(style);
      this.shadow.appendChild(loader);
      this.shadow.appendChild(loadMore);

      _getProjects(this, false, true, false, 20);

      loadMore.addEventListener('click', (e) => this.loadMoreProjects(e));
    }

    createTags(tags, project) {
      const { StartYear: year, ProjType: type, Department: department, Phase: phase, Status: status } = project;

      [year, type, department, phase, status].forEach((tag, index) => {
        tags[index].textContent = tag;
      });

      return tags;
    }

    loadMoreProjects(e) {
      const projectSearchForm = currentDocument.querySelector('#project-search-form');
      const form = projectSearchForm.shadowRoot.querySelector('.project-search__form');
      const formElements = form.elements;
      const queryParams = _getQueryParams(formElements);
      const projectIndex = this.shadowRoot.querySelectorAll('.project-search__result:not(.project-search__result--sticky)').length + 20;

      return queryParams.length > 0 ? _getProjects(this, queryParams, false, true, projectIndex) : _getProjects(this, false, false, true, projectIndex);
    }

    renderNoResults() {
      const errorMsg = this.template.content.children[1].cloneNode(true);

      errorMsg.textContent = 'No results found.';
      this.shadow.appendChild(errorMsg);

      // hide loader
      this.shadow.children[1].style = 'display: none !important;';
    }

    render(project) {
      const instance = this.template.content.children[3].cloneNode(true);
      const title = instance.querySelector('.project-search__result-title');
      const description = instance.querySelector('.project-search__result-description');
      const details = instance.querySelector('.project-search__result-button--no-details');
      const map = instance.querySelector('.project-search__result-button--map');
      const tags = instance.querySelectorAll('.project-search__result-tag');

      // hide loader
      this.shadow.children[1].style = 'display: none';

      title.textContent = project.Name;
      map.href = mapUrl + project.ProjectID;

      if (project.Sticky) {
        instance.classList.add('project-search__result--sticky');
      }

      if (project.Description) {
        description.textContent = project.Description;
      }

      if (project.DrupalUrl) {
        const anchor = document.createElement('a');
        anchor.href = project.DrupalUrl;
        anchor.textContent = title.textContent;
        title.classList.remove('project-search__result-title--no-details');
        title.textContent = '';
        title.insertAdjacentHTML('beforeend', `<a href="${project.DrupalUrl}">${anchor.textContent}</a>`);
        details.href = project.DrupalUrl;
        details.textContent = 'Project Details';
        details.classList.remove('project-search__result-button--no-details');
      }

      this.createTags(tags, project);

      this.shadow.appendChild(instance);
    }
  }

  customElements.define('project-search-results', ProjectSearchResults);
  customElements.define('project-search-form', ProjectSearchForm);
})();
